import flowRight from 'lodash/flowRight'
import withDialog from 'shared/hocs/withDialog'
import React, { ReactNode } from 'react'
import DeleteIcon from 'assets/icons/delete.svg'
import styled from 'styled-components'
import Loader from 'shared/components/Loader'
import Box from '../Box'

type ConfirmDialogProps = {
  message?: string | ReactNode
  icon?: string | ReactNode
  isProcessing?: boolean
}

function Confirm(props: ConfirmDialogProps) {
  const { message, icon, isProcessing = false } = props

  return (
    <ConfirmDialogBodyContainer>
      {isProcessing && <Loader />}
      {!isProcessing && (
        <>
          {icon && (
            <IconContainer>
              {typeof icon === 'string' ? <img src={!icon ? DeleteIcon : icon} /> : icon}
            </IconContainer>
          )}
          {message && typeof message === 'string' ? <MessageContainer>{message}</MessageContainer> : message}
        </>
      )}
    </ConfirmDialogBodyContainer>
  )
}

const ConfirmDialogBodyContainer = styled(Box)`
  margin: 0 40px;
`

const IconContainer = styled(Box)`
  margin-top: 40px;
  display: flex;
  justify-content: center;

  img {
    max-height: 100%;
  }
`

export const MessageContainer = styled.div`
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  padding-top: 24px;
`

const ConfirmDialog = flowRight(withDialog())(Confirm)

ConfirmDialog.defaultProps = {
  titleClassName: 'dialog__title--no-capitalize',
}

export const Confirmation = Confirm
export default ConfirmDialog
